"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.variationCriterias = void 0;
var rubric_variations_enum_1 = require("../constants/rubric-variations.enum");
/**
 * Returns the list of criterias based on the item rating variation
 * @param {Variations}      variation       - Item Rating variation
 *
 * @return list of criterias based on the variation
 */
var variationCriterias = function (variation) {
    switch (variation) {
        case rubric_variations_enum_1.Variations.A: {
            return rubric_variations_enum_1.VariationA;
        }
        case rubric_variations_enum_1.Variations.B: {
            return rubric_variations_enum_1.VariationB;
        }
        case rubric_variations_enum_1.Variations.C: {
            return rubric_variations_enum_1.VariationC;
        }
        case rubric_variations_enum_1.Variations.D: {
            return rubric_variations_enum_1.VariationD;
        }
        default: {
            return rubric_variations_enum_1.VariationD;
        }
    }
};
exports.variationCriterias = variationCriterias;
